import AppSetting from '../../common/constants/appsetting.constant';
import StorageService from '../session/storage.service';
import StorageType from '../session/storage.enum';
import CommonService from './common.service';
import UserTypeEnum from '../../common/enum/user-type.enum';
import axios from 'axios'

const TreatmentPlanService = {

  getLoggedInData() {
    return JSON.parse(StorageService.get('session', 'userDetails'));
  },

  getAllTreatmentPlan(reqObj) {
    this.loggedInUserData = this.getLoggedInData();
    let url;

    url = AppSetting.patient.getAllTreatmentPlan
      .replace('{parentId}', this.getLoggedInData()['parentId'])
      + this.buildQuery(reqObj);

    return axios.get(url)
      .then(a => { return a })
      .catch(err => {return err})
  },

  addTreatmentPlan(reqObj) {
    this.loggedInUserData = this.getLoggedInData();
    let url = '';

    url = AppSetting.patient.addTreatmentPlan
      .replace('{parentId}', this.getLoggedInData()['parentId']);

    return axios.post(url, reqObj)
      .then(a => { return a})
      .catch(err => {return err})

  },

  editTreatmentPlan(reqObj) {
    let url = '';
    url = AppSetting.patient.editTreatmentPlan
      .replace('{parentId}', this.getLoggedInData()['parentId'])
      .replace('{treatmentPlanId}', reqObj.treatmentPlanId);
    return axios.put(url, reqObj)
      .then(a => { 
        return a 
      })
      .catch(err => console.log(err))
  },
  deleteTreatmentPlan(treatmentPlanId) {
    let loggedInUserData = this.getLoggedInData();
    let url = AppSetting.patient.editTreatmentPlan.replace('{parentId}', loggedInUserData['parentId']).replace('{treatmentPlanId}', treatmentPlanId)
    return axios.delete(url)
      .then((res) => { return res })
      .catch(err => this.handleError(err))
  },

  buildQuery(data) {
    let queryData = '';
    for (const prop in data) {
      if (data[prop] !== '' && data[prop] !== 'undefined' && data[prop] !== null) {
        if (queryData === '') {
          queryData = '?' + prop + '=' + data[prop];
        } else {
          queryData += '&' + prop + '=' + data[prop];
        }
      }
    } return queryData;
  },
  handleError(error) {
    return (error) => {
      // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`operation failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return console.log(error);
      // return Observable.throw(error.json().error || error.message);
      // return of(result as T);
    };
  },
  /** Log a HeroService message with the MessageService */
  log(message) {
    // this.messageService.add('HeroService: ' + message);
  },
}

export default TreatmentPlanService